import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';

const instrumentationKey = process.env.REACT_APP_INSIGHT_INSTRUMENTATION_KEY;

// eslint-disable-next-line import/no-mutable-exports
let appInsights: ApplicationInsights | undefined;
if (instrumentationKey) {
  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey,
      extensionConfig: {},
    },
  });

  const telemetryInitializer = (envelope: ITelemetryItem): void => {
    if (envelope.tags) {
      // eslint-disable-next-line no-param-reassign
      envelope.tags['ai.cloud.role'] = 'min-side';
    }
  };

  appInsights.addTelemetryInitializer(telemetryInitializer);

  appInsights.loadAppInsights();
}

export default appInsights;
